import { c as _c } from "react/compiler-runtime";
import { IcoCode216 } from '@onefootprint/icons';
import SandboxToggle from '@/components/sandbox-toggle';
const EnvironmentBanner = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center justify-between h-11 px-5 bg-senary/40 w-full"><div className="flex gap-1 items-center"><IcoCode216 /><span className="text-label-3 text-primary">Environment</span></div><SandboxToggle /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default EnvironmentBanner;